import axios from "axios";

export const pkiAxios = axios.create();

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

const updateProfileService = {
    getCodeForPhoneEmailVerification: async (payload) => {
        try {
            // const response = await axios.post(`${API_ENDPOINT}updateProfile/sendOTP`, payload);
            const response = await axios.post(`${API_ENDPOINT}updateProfile/sendOTP`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error; // Re-throw to handle in components
        }
    },

    verifyEmailCode: async (payload) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}updateProfile/verifyOTPEmail`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error; // Re-throw to handle in components
        }
    },

    verifyPhoneEmailCode: async (payload) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}updateProfile/verifyOTP`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error; // Re-throw to handle in components
        }
    },

    updatePhoneEmailCode: async (payload) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}updateProfile/update-phone`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error; // Re-throw to handle in components
        }
    },

    updateProfileDetails: async (payload) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}updateProfile/update-profile`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error; // Re-throw to handle in components
        }
    },

    updateProfileDetailsOfOthers: async (payload) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}updateProfile/update-profile-for-others`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error; // Re-throw to handle in components
        }
    },

    getUserDetails: async (payload) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}updateProfile/userDetails`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error; // Re-throw to handle in components
        }
    },

    updatePhoneNumber: async (payload) => {
    try {
        const response = await axios.post(`${API_ENDPOINT}updateProfile/update-phone`, payload);
        return response.data;
    } catch (error) {
        console.error("Error fetching form data:", error);
        throw error; // Re-throw to handle in components
    }
    },
};

export default updateProfileService;